import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { api } from "../../config/api";
import { util } from "../../config/util";
import { Cookies } from "../../constants/Cookies";
import { pages } from "../../constants/PagePaths";
import AlertContext from "../../contexts/AlertContext";
import EducationApplicationPresenter from "./EducationApplicationPresenter";
interface Props {}

export default (props: Props) => {
  const [isSended, setIsSended] = useState(false);
  const [userInfo, setUserInfo] = useState<any>(null);
  const alertContext = useContext(AlertContext);
  const history = useHistory();

  // 로그인 체크 및 사용자 정보 가져오기
  useEffect(() => {
    const authKey = util.getCookie(Cookies.authKey);
    if (!authKey) {
      alertContext.showAlert("로그인이 필요한 서비스입니다.", () => {
        history.push(pages.login);
      });
      return;
    }

    // 사용자 정보 가져오기
    api.getMyInfo()
      .then((result: any) => {
        setUserInfo(result.data);
      })
      .catch((error) => {
        alertContext.showAlert("사용자 정보를 가져오는데 실패했습니다.", () => {
          history.push(pages.login);
        });
      });
  }, []);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (isSended) return;

    const formData = new FormData();
    for (let index = 0; index < e.target.length; index++) {
      const element = e.target[index];
      if (
        (element.type === "text" ||
          element.type === "textarea" ||
          element.type === "email" ||
          element.type === "number" ||
          element.type === "tel" ||
          element.type === "select-one") &&
        element.name !== ""
      ) {
        formData.append(element.name, element.value);
      } else if (element.type === "radio" || element.type === "checkbox") {
        if (element.checked) {
          // 기타 근무처인 경우 workplace_other 값도 함께 전송
          if (element.name === "workplace" && element.value === "기타") {
            const otherInput = e.target.querySelector('input[name="workplace_other"]');
            if (otherInput && otherInput.value) {
              formData.append(element.name, `기타: ${otherInput.value}`);
            } else {
              formData.append(element.name, element.value);
            }
          // 기타 알게 된 경로인 경우 source_other 값도 함께 전송
          } else if (element.name === "source" && element.value === "기타") {
            const otherInput = e.target.querySelector('input[name="source_other"]');
            if (otherInput && otherInput.value) {
              formData.append(element.name, `기타: ${otherInput.value}`);
            } else {
              formData.append(element.name, element.value);
            }
          } else {
            formData.append(element.name, element.value);
          }
        }
      }
    }

    setIsSended(true);
    alertContext.showAlert("전송중입니다...");
    
    try {
      // 교육 신청 API 호출
      const res = await api.postEducationApplication(formData);
      
      if (res.status === 200) {
        alertContext.showAlert(
          "교육 신청이 완료되었습니다.\n기재하신 이메일을 통해\n추후 개별 연락이 진행될 예정입니다.",
          () => {
            history.push(pages.mypage);
          }
        );
      }
    } catch (err) {
      alertContext.showAlert(
        "교육 신청 전송 중 오류가 발생하였습니다.\n 우측 하단 아이콘을 통해 고객센터에 문의 부탁드립니다."
      );
    } finally {
      setIsSended(false);
    }
  };

  if (!userInfo) {
    return <div>로딩 중...</div>;
  }

  return (
    <EducationApplicationPresenter
      userInfo={userInfo}
      onSubmit={handleSubmit}
    />
  );
}; 